document.addEventListener('DOMContentLoaded', () => {
    const counterElements = document.querySelectorAll(
        '.wp-block-ifdigital-if-counter--counteritem-value'
    );

    if (!counterElements.length) {
        return;
    }

    const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;
    const animationFrames = new WeakMap();

    const getTargetNumber = (element) => {
        const parsedTarget = Number.parseInt(
            element.getAttribute('data-ifcounter'),
            10
        );
        return Number.isNaN(parsedTarget) ? 0 : parsedTarget;
    };

    const stopAnimation = (element) => {
        const frameId = animationFrames.get(element);
        if (frameId) {
            window.cancelAnimationFrame(frameId);
            animationFrames.delete(element);
        }
    };

    const resetCounter = (element) => {
        stopAnimation(element);
        element.textContent = '0';
    };

    const startCounter = (element) => {
        stopAnimation(element);

        const targetNumber = getTargetNumber(element);
        if (targetNumber <= 0) {
            element.textContent = '0';
            return;
        }

        if (prefersReducedMotion) {
            element.textContent = String(targetNumber);
            return;
        }

        const duration = 1200;
        const startAt = performance.now();

        const step = (now) => {
            const progress = Math.min((now - startAt) / duration, 1);
            const nextValue = Math.round(progress * targetNumber);
            element.textContent = String(nextValue);

            if (progress < 1) {
                const nextFrameId = window.requestAnimationFrame(step);
                animationFrames.set(element, nextFrameId);
            } else {
                animationFrames.delete(element);
            }
        };

        const frameId = window.requestAnimationFrame(step);
        animationFrames.set(element, frameId);
    };

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    startCounter(entry.target);
                    return;
                }

                resetCounter(entry.target);
            });
        },
        {
            root: null,
            rootMargin: '0px',
            threshold: 0.2,
        }
    );

    counterElements.forEach((element) => {
        element.textContent = '0';
        observer.observe(element);
    });
});
